import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import ReactTable, { ReactTableDefaults } from 'react-table';

import {
  ReactTableFilterDatePicker,
  ReactTableSearch,
  ReactTablePagination,
  ReactTableHeaderText,
  ExamAttachTableMenu,
  ModalTemplate,
  AttachLabel,
  Loading
} from 'components';
import { Icon, Label, Image, Popup } from 'semantic-ui-react';

import * as commonVar from 'libs/commonVar';
import * as common from 'libs/commonFunc';

import moment from 'moment';
import 'moment/locale/ko';
import 'moment/locale/ja';

import classNames from 'classnames/bind';
import styles from './ExamAttachList.css';
const cx = classNames.bind(styles);

moment.locale(localStorage.getItem('language'));

class ExamAttachList extends PureComponent {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { data, fromNowView, isAuth, ...rest } = this.props;
    // 실행 결과
    const { isModal, actionImagePath, onToggleModal } = this.props;
    // 검색 (상단)
    const { searchObj } = this.props;
    // 필터
    const {
      handleChangeDateFilter,
      onToggleActionImageModal,
      attachCategoryFilter,
      attachExamTypeFilter,
      attachFunctionFilter,
      attachRestrictFilter,
      isEnableFilter,
      cancleCheck,
      filterClose,
      executeFilter,
      onFilterCancel
    } = this.props;
    // 현재 페이지 이동 (하단)
    const { handlePagination } = this.props;

    const columns = [
      {
        Header: <ReactTableHeaderText title={'No'} />,
        accessor: 'attachInfoNo',
        resizable: false,
        sortable: true,
        width: 72,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center number-text')
      },
      {
        Header: <ReactTableHeaderText title={defineMessages(formatMessage({ id: 'ExamAttachList_22', defaultMessage: '서비스No' }))} />,
        accessor: 'serviceNo',
        resizable: false,
        sortable: true,
        width: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center number-text'),
        Cell: ({ value }) => {
          return value ? value : '-'
        },
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamAttachList_2', defaultMessage: '구분' }))}
            />
          );
        },
        accessor: 'isBasic',
        id: 'isBasic',
        sortable: true,
        resizable: false,
        width: 90,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = (
            <Label basic size="small" className={cx('template-type-label color-temp-user')}>
              {defineMessages(formatMessage({ id: 'ExamTemplateList_3', defaultMessage: '사용자' }))}
            </Label>
          );
          if (value) {
            printValue = (
              <Label basic size="small" className={cx('template-type-label color-temp-system')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_2', defaultMessage: '기 본' }))}
              </Label>
            );
          }
          return printValue;
        }
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [
            {
              key: '1',
              text: defineMessages(formatMessage({ id: 'ExamAttachCategory_1', defaultMessage: '실행파일' })),
              value: 1
            },
            {
              key: '2',
              text: defineMessages(formatMessage({ id: 'ExamAttachCategory_2', defaultMessage: '바로가기' })),
              value: 2
            },
            {
              key: '3',
              text: defineMessages(formatMessage({ id: 'ExamAttachCategory_3', defaultMessage: '문서파일' })),
              value: 3
            },
            {
              key: '4',
              text: defineMessages(formatMessage({ id: 'ExamAttachCategory_4', defaultMessage: '웹문서' })),
              value: 4
            }
          ];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamAttachList_21', defaultMessage: '첨부 유형' }))}
            // filter={
            //   <ReactTableFilterDropdown
            //     listItem={listItem}
            //     filter={searchObj.filterData}
            //     handleChangeFilter={handleChangeFilter}
            //     column={rest.column.id}
            //   />
            // }
            />
          );
        },
        accessor: 'attachCategory',
        sortable: true,
        resizable: false,
        minWidth: 115,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value === 1) {
            printValue = (
              <Label basic size="small" className={cx('template-type-label color-attach-exe')}>
                {defineMessages(formatMessage({ id: 'ExamAttachCategory_1', defaultMessage: '실행파일' }))}
              </Label>
            );
          } else if (value === 2) {
            printValue = (
              <Label basic size="small" className={cx('template-type-label color-attach-lnk')}>
                {defineMessages(formatMessage({ id: 'ExamAttachCategory_2', defaultMessage: '바로가기' }))}
              </Label>
            );
          } else if (value === 3) {
            printValue = (
              <Label basic size="small" className={cx('template-type-label color-attach-doc')}>
                {defineMessages(formatMessage({ id: 'ExamAttachCategory_3', defaultMessage: '문서파일' }))}
              </Label>
            );
          } else if (value === 4) {
            printValue = (
              <Label basic size="small" className={cx('template-type-label color-attach-html')}>
                {defineMessages(formatMessage({ id: 'ExamAttachCategory_4', defaultMessage: '웹문서' }))}
              </Label>
            );
          } else {
            // 나머지
          }
          return printValue;
        }
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [
            {
              key: 'warning',
              text: defineMessages(formatMessage({ id: 'ExamTemplateList_32', defaultMessage: '경고 안내' })),
              value: '1'
            },
            {
              key: 'exam',
              text: defineMessages(formatMessage({ id: 'ExamTemplateList_14', defaultMessage: '모의 악성파일' })),
              value: '2'
            },
            {
              key: 'hidden',
              text: defineMessages(formatMessage({ id: 'ExamTemplateList_15', defaultMessage: '실태 조사' })),
              value: '3'
            }
          ];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamTemplateList_13', defaultMessage: '훈련 유형' }))}
            // filter={
            //   <ReactTableFilterDropdown
            //     listItem={listItem}
            //     filter={searchObj.filterData}
            //     handleChangeFilter={handleChangeFilter}
            //     column={rest.column.id}
            //   />
            // }
            />
          );
        },
        accessor: 'attachExamType',
        id: 'attachExamType',
        sortable: true,
        resizable: false,
        width: 133,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value === 1) {
            printValue = (
              <Label basic size="small" className={cx('template-type-label color-temp-warning')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_32', defaultMessage: '경고 안내' }))}
              </Label>
            );
          } else if (value === 2) {
            printValue = (
              <Label basic size="small" className={cx('template-type-label color-temp-file')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_14', defaultMessage: '모의 악성파일' }))}
              </Label>
            );
          } else if (value === 3) {
            printValue = (
              <Label basic size="small" className={cx('template-type-label color-temp-research')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_15', defaultMessage: '실태 조사' }))}
              </Label>
            );
          } else {
            // 나머지
          }
          return printValue;
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamAttachList_3', defaultMessage: '아이콘' }))}
          />
        ),
        accessor: 'fileIcon',
        id: 'fileIcon',
        sortable: false,
        resizable: false,
        minWidth: 72,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ original }) => {
          return original.fileIcon ? (
            <Image
              className={cx('attach-fileIcon')}
              src={'/fdata/attachFile/' + original.attachInfoNo + '/' + original.fileIcon}
            />
          ) : (
              <div className={cx('text-align-center')}>-</div>
            );
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamAttachList_4', defaultMessage: '확장자' }))}
          />
        ),
        accessor: 'fileExt',
        sortable: true,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value) {
            printValue = value;
          }
          return printValue;
        }
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [
            { key: 'PG', text: 'PG', value: 'PG' },
            { key: 'LG', text: 'LG', value: 'LG' },
            { key: 'PL', text: 'PL', value: 'PL' },
            { key: 'VS', text: 'VS', value: 'VS' }
          ];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamAttachList_5', defaultMessage: '부가 기능' }))}
            // filter={
            //   <ReactTableFilterDropdown
            //     listItem={listItem}
            //     filter={searchObj.filterData}
            //     handleChangeFilter={handleChangeFilter}
            //     column={rest.column.id}
            //   />
            // }
            />
          );
        },
        accessor: 'attachFunction',
        sortable: false,
        resizable: false,
        minWidth: 162,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td'),
        Cell: ({ value }) => {
          let printValue = <div className={cx('text-align-center')}>-</div>;
          if (!!value && value !== '{}') {
            printValue = <AttachLabel type="attachFunction" value={value} />;
          }
          return printValue;
        }
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [
            { key: 'UAC', text: 'UAC', value: 'UAC' },
            { key: 'SS', text: 'SS', value: 'SS' },
            { key: 'VD', text: 'VD', value: 'VD' },
            { key: 'SF', text: 'SF', value: 'SF' },
            { key: 'LC', text: 'LC', value: 'LC' },
            { key: 'UC', text: 'UC', value: 'UC' },
            { key: 'DW', text: 'DW', value: 'DW' }
          ];

          return (
            <ReactTableHeaderText
              title={
                <Popup
                  trigger={
                    <a
                      href={'/attachRestrict_' + localStorage.getItem('language') + '.html'}
                      target="restrict"
                      className={cx('attach-list-restrict', 'white')}
                      onClick={e => e.stopPropagation()}>
                      {defineMessages(formatMessage({ id: 'ExamAttachList_6', defaultMessage: '제약 사항' }))}
                      <Icon name="info circle" className={cx('ml-5')} />
                    </a>
                  }>
                  {defineMessages(
                    formatMessage({
                      id: 'ExamAttachList_19',
                      defaultMessage: "부가기능, 제약사항 설명 페이지 'Click!'"
                    })
                  )}
                </Popup>
              }
            // filter={
            //   <ReactTableFilterDropdown
            //     listItem={listItem}
            //     filter={searchObj.filterData}
            //     handleChangeFilter={handleChangeFilter}
            //     column={rest.column.id}
            //   />
            // }
            />
          );
        },
        accessor: 'attachRestrict',
        sortable: false,
        resizable: false,
        minWidth: 300,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td'),
        Cell: ({ value }) => {
          let printValue = <div className={cx('text-align-center')}>-</div>;
          if (!!value && value !== '{}') {
            printValue = <AttachLabel type="attachRestrict" value={value} />;
          }
          return printValue;
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamAttachList_20', defaultMessage: '실행예시' }))}
          />
        ),
        accessor: 'actionImage',
        sortable: false,
        resizable: false,
        minWidth: 72,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ original }) => {
          // 팝업으로 이미지 표시
          return original.actionImage ? (
            <Icon
              name="zoom in"
              size="large"
              link
              onClick={() => {
                onToggleActionImageModal({
                  viewType: 'actionImage',
                  image: '/fdata/attachFile/' + original.attachInfoNo + '/' + original.actionImage
                });
              }}
            />
          ) : (
              <div className={cx('text-align-center')}>-</div>
            );
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamAttachList_1', defaultMessage: '제목' }))}
          />
        ),
        accessor: 'attachSubject',
        sortable: true,
        minWidth: 235,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td sub-text'),
        Cell: ({ value }) => {
          return value ? value : <div className={cx('text-align-center')}>-</div>;
        }
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamTemplateEdit_32', defaultMessage: '공개 여부' }))}
            />
          );
        },
        accessor: 'isPublic',
        id: 'isPublic',
        sortable: true,
        resizable: false,
        width: 110,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value === 1) {
            printValue = 'O';
          }
          return printValue;
        }
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [{ key: '0', text: 'O', value: '0' }, { key: '1', text: '-', value: '1' }];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamAttachList_10', defaultMessage: '삭제 여부' }))}
            // filter={
            //   <ReactTableFilterDropdown
            //     listItem={listItem}
            //     filter={searchObj.filterData}
            //     handleChangeFilter={handleChangeFilter}
            //     column={rest.column.id}
            //   />
            // }
            />
          );
        },
        accessor: 'isEnable',
        id: 'isEnable',
        sortable: true,
        resizable: false,
        width: 110,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value === 0) {
            printValue = 'O';
          }
          return printValue;
        }
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamAttachList_11', defaultMessage: '수정일' }))}
            // filter={
            //   <ReactTableFilterDatePicker
            //     {...rest}
            //     filter={searchObj.filterData}
            //     onChange={data => {
            //       handleChangeDateFilter('ModifyEpoch', data);
            //     }}
            //   />
            // }
            />
          );
        },
        accessor: 'modifyEpoch',
        sortable: true,
        resizable: false,
        minWidth: 177,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center sub-text'),
        Cell: ({ value }) => {
          const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
          return (
            <div>
              <span className={cx('log-reg-date-normal')}>{moment.unix(value).format(dateFormat + ' HH:mm:ss')}</span>
              <span className={cx('log-reg-date-fromnow')}>{moment.unix(value).fromNow()}</span>
            </div>
          );
        }
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamAttachList_12', defaultMessage: '등록일' }))}
              filter={
                <ReactTableFilterDatePicker
                  {...rest}
                  filter={searchObj.filterData}
                  onChange={data => {
                    handleChangeDateFilter('RegEpoch', data);
                  }}
                />
              }
            />
          );
        },
        accessor: 'regEpoch',
        sortable: true,
        resizable: false,
        minWidth: 177,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center sub-text'),
        Cell: ({ value }) => {
          const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
          return (
            <div>
              <span className={cx('log-reg-date-normal')}>{moment.unix(value).format(dateFormat + ' HH:mm:ss')}</span>
              <span className={cx('log-reg-date-fromnow')}>{moment.unix(value).fromNow()}</span>
            </div>
          );
        }
      }
    ];

    // 구축형일때는 설정 부분 제거
    if (commonVar.isSaas === 1) {
      columns.unshift({
        Header: <ReactTableHeaderText title={<Icon name="setting" />} />,
        resizable: false,
        sortable: false,
        width: 120,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'justify-center'),
        Cell: ({ original }) => {
          return <ExamAttachTableMenu isAuth={isAuth} templateInfo={{ ...original }} />;
        }
      });

      columns.push({
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamAttachList_8', defaultMessage: '파일명' }))}
          />
        ),
        accessor: 'fileName',
        sortable: true,
        minWidth: 261,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td sub-text'),
        Cell: ({ value }) => {
          return value ? value : <div className={cx('text-align-center')}>-</div>;
        }
      });
      columns.push({
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamAttachList_9', defaultMessage: '파일용량' }))}
          />
        ),
        accessor: 'fileSize',
        sortable: true,
        resizable: false,
        minWidth: 106,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center sub-text'),
        Cell: ({ value }) => {
          return value ? common.fileSizeTrans(value).common : <div className={cx('text-align-center')}>-</div>;
        }
      });
    }

    const { TbodyComponent: tbadyWrapper } = ReactTableDefaults;

    return (
      <div className={cx('react-table-area', fromNowView ? 'from-now-view' : '')}>
        {isModal === 'actionImage' && (
          <ModalTemplate
            closeOnEscape={false}
            closeOnDimmerClick={false}
            className={cx('modal-actionImage', 'common-content')}
            closeIcon
            onToggleModal={onToggleModal}
            visible
            header={
              <div>{defineMessages(formatMessage({ id: 'ExamAttachList_13', defaultMessage: '실행결과 이미지' }))}</div>
            }>
            <Image src={actionImagePath} />
          </ModalTemplate>
        )}
        <ReactTableSearch
          searchObj={searchObj}
          listData={data}
          // 필터 영역
          filters={{
            attachCategoryFilter: attachCategoryFilter,
            attachExamTypeFilter: attachExamTypeFilter,
            attachFunctionFilter: attachFunctionFilter,
            attachRestrictFilter: attachRestrictFilter,
            isEnableFilter: isEnableFilter
          }}
          cancleCheck={cancleCheck}
          filterClose={filterClose}
          executeFilter={executeFilter}
          onFilterCancel={onFilterCancel}
        />
        <div className={cx('react-table')}>
          <ReactTable
            columns={columns}
            data={data}
            sortable={false}
            filterable={false}
            showPagination={false}
            showPageSizeOptions={false}
            defaultSorted={[
              {
                id: 'attachInfoNo',
                desc: true
              }
            ]}
            loadingText={defineMessages(
              formatMessage({ id: 'ExamTemplateList_23', defaultMessage: '데이터 로딩중...' })
            )}
            LoadingComponent={({ ...rest }) => <Loading active={rest.loading} content={rest.loadingText} />}
            FilterComponent={({ ...rest }) => <div />}
            TbodyComponent={({ ...rest }) => (
              <div style={{ ...rest.style }} className={cx('react-table-tbody-wrapper')}>
                <tbadyWrapper {...rest} className={cx('rt-tbody', rest.className ? rest.className : '')} />
              </div>
            )}
            NoDataComponent={({ ...rest }) => (
              <div className={cx('noData-area')}>
                <Image src="/img/table/nodata_icon.png" />
                {defineMessages(formatMessage({ id: 'ExamTemplateList_24', defaultMessage: '데이터가 없습니다.' }))}
              </div>
            )}
            getTheadThProps={(state, rowInfo, column) => {
              const filter = [];
              if (column) {
                // 필터 처리
                if (typeof searchObj.filterData[column.id] !== 'undefined') {
                  filter.push('isFiltered');
                }
                // 정렬 제공 안하는 header
                if (!column.sortable) {
                  filter.push('no-sort');
                }

                return filter.length > 0
                  ? {
                    className: filter.join(' ')
                  }
                  : {};
              }
            }}
            getTrProps={(state, rowInfo, column) => {
              if (rowInfo && rowInfo.original && rowInfo.original.isEnable === 0) {
                return {
                  className: 'delete-item'
                };
              } else {
                return {};
              }
            }}
            {...rest}
          />
        </div>
        <ReactTablePagination
          currentPage={rest.page}
          totalPages={rest.pages ? rest.pages : 0}
          handlePagination={handlePagination}
        />
      </div>
    );
  }
}

export default injectIntl(ExamAttachList);



// WEBPACK FOOTER //
// ./src/script/components/examAttach/ExamAttachList.js